import React from 'react';
import { RenderModule } from 'holocron';
import { Heading } from '@americanexpress/dls-react';
import { IconHotel } from '@americanexpress/dls-icons';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';
import sharedStyles from '../../styles/shared.scss';

const SearchComponent = () => {
  const heading = useDataFromOneCMS('searchSection.heading');
  const subheading = useDataFromOneCMS('searchSection.subheading');
  const finePrint = useDataFromOneCMS('searchSection.finePrint');

  return (
    <div className="dls-bright-blue-bg">
      <div className="container pad-2-t pad-4-b pad-0-t-sm-down pad-2-b-sm-down pad-2-lr-sm-down">
        <div className="color-graphic-brand-logo-blue-box-text text-align-center pad-3-tb pad-2-lr-sm-down">
          <IconHotel
            size="md"
            className="pad-2-b"
            aria-hidden="true"
            color="white"
          />
          <Heading level={2} variant="sans-large-book" className={sharedStyles.heading}>
            {' '}
            {heading}{' '}
          </Heading>
          <div className="pad-1-t body-3">
            <span>{subheading}</span>
          </div>
        </div>
        <div id="searchComponent">
          <div className="pad-1-t pad-2-l legal-1 color-graphic-brand-logo-blue-box-text">{finePrint}</div>
          <RenderModule
            moduleName="axp-travel-search-hotels"
            props={{
              theme: 'blue',
              searchRedirectConfig: { filterFHR: true, filterTHC: true },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchComponent;
